import api from '@/api/api';

class CapabilityService {

    getCapabilities(exerciseId) {
        return api().get(`/exercise/${exerciseId}/capabilities`);
    }

    generateTip(exerciseId, courseName) {
        return api().post(`/exercise/${exerciseId}/pedagogical-tip`, { course_name: courseName });
    }
}

export default new CapabilityService();
